import upload from '@/services/upload'
import createFileName from './../dataMapping/createFileName'

const UploadGLB = async (glbFile, state) => {
  return new Promise((resolve, reject) => {
    const fileName = createFileName(state.product, 'glb')
    upload({
      file: glbFile,
      fileName: fileName,
      folderName: 'glb_files',
    })
      .then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
}
export default UploadGLB
